"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 12.877l4.523 4.523.877-.877L12.877 12 17.4 7.477l-.877-.877L12 11.123 7.477 6.6l-.877.877L11.123 12 6.6 16.523l.877.877L12 12.877z" }), "Close");
//# sourceMappingURL=Close.js.map